import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {lastValueFrom} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class CrudService<T> {

  ROUTE: string;

  constructor(
    protected http: HttpClient,
  ) {}

  async getOne (id: number, route: string, query = '') {
    const $result = this.http.get(`${environment.BASE_PATH}/${route || this.ROUTE}/${id}?${query}`);
    return await lastValueFrom($result);
  }

  async getMany (route: string, query = '') {
    const $result = this.http.get(`${environment.BASE_PATH}/${route || this.ROUTE}?${query}`);
    return await lastValueFrom($result);
  }

  async createOne (route: string, entity: any) {
    const $result = this.createOneObservable(route || this.ROUTE, entity);
    return await lastValueFrom($result);
  }

  createOneObservable (route: string, entity: any) {
    return this.http.post<any>(`${environment.BASE_PATH}/${route || this.ROUTE}`, entity);
  }

  async createMany(route: string, entities: any[]) {
    const $result = this.http.post<any>(`${environment.BASE_PATH}/${route || this.ROUTE}`, {bulk: entities});
    return await lastValueFrom($result);
  }

  async deleteOne (route: string, entityId: number) {
    const $result = this.deleteOneObservable(route || this.ROUTE, entityId);
    return await lastValueFrom($result);
  }

  deleteOneObservable (route: string, entityId: number) {
    return this.http.delete<any>(`${environment.BASE_PATH}/${route || this.ROUTE}/${entityId}`);
  }

  async replaceOne(route: string, entity: any) {
    const $result = this.replaceOneObservable(route || this.ROUTE, entity);
    return await lastValueFrom($result);
  }

  replaceOneObservable(route: string, entity: any) {
    return this.http.put<any>(`${environment.BASE_PATH}/${route || this.ROUTE}/${entity.id}`, entity);
  }

  async getOneTypified(id: number, query: string = '') {
    return (await this.getOne(id, this.ROUTE, query) as T);
  }

  async getManyTypified(query: string = '', route= this.ROUTE) {
    const res = (await this.getMany(route, query) as any);
    return res?.data as T[];
  }

  async createOneTypified(entity: any) {
    return (await this.createOne(this.ROUTE, entity) as T);
  }

  async replaceOneTypified(entity: any) {
    return (await this.replaceOne(this.ROUTE, entity) as T);
  }
}
